var DatasetRuleService = /** @class */ (function () {
    function DatasetRuleService(api) {
        var _this = this;
        this.fetchDatasetRules = function (datasetId, appId) {
            return _this.API.get("/datasets/".concat(datasetId, "/rules?app=").concat(appId));
        };
        this.createDatasetRule = function (datasetId, rule, appId) {
            return _this.API.post("/datasets/".concat(datasetId, "/rules?app=").concat(appId), rule);
        };
        this.updateDatasetRule = function (datasetId, rule) {
            return _this.API.put("/datasets/".concat(datasetId, "/rules/").concat(rule.id), rule);
        };
        this.deleteDatasetRule = function (datasetId, ruleId) {
            return _this.API.delete("/datasets/".concat(datasetId, "/rules/").concat(ruleId));
        };
        this.API = api;
    }
    return DatasetRuleService;
}());
export { DatasetRuleService };
